/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect, useState } from 'react';
type TFunArgs = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds: number;
};
interface ICountdown {
  onUnMount?: (args: TFunArgs) => void;
  onChange?: (args: TFunArgs) => void;
  removeFun?: () => void;
  enabled?: boolean;
}
const useCountdown = (
  targetDate: any,
  { onUnMount, onChange, removeFun, enabled }: ICountdown
) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime()
  );

  useEffect(() => {
    if (!enabled) {
      removeFun?.();
      return;
    }
    const interval = setInterval(() => {
      onChange?.(getReturnValues(countDown));
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => {
      onUnMount?.(getReturnValues(countDown));
      return clearInterval(interval);
    };
  }, [countDownDate]);

  return {
    ...getReturnValues(countDown),
    isTimerFinish: enabled ? getReturnValues(countDown).minutes < 0 : true,
  };
};

const getReturnValues = (countDown: number) => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
  const milliseconds = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;
  return { days, hours, minutes, seconds, milliseconds };
};

export { useCountdown };
